export function useAddressApi() {
  const { errors, request } = useRequestV2();

  async function CreateAssociatedAddress(requestBody: CreateAssociatedAddressRequestDTO) {
    const url = 'V3/Address/CreateAssociatedAddress';

    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<CreateAssociatedAddressResponseDTO>(url, requestOptions);
  }

  return {
    errors,
    CreateAssociatedAddress
  };
}
